import type { Components, Theme } from "@mui/material";

export const dialogTheme: Components<Theme>["MuiDialog"] = {
  styleOverrides: {
    paper: ({ theme }) => ({
      borderRadius: theme.borderRadius.md,
      [theme.breakpoints.down("sm")]: {
        margin: 0,
        width: "100%",
      },
      [theme.breakpoints.up("sm")]: {
        margin: theme.spacing(4),
      },
    }),
    paperFullScreen: ({ theme }) => ({
      background: theme.palette.background.main,
      borderRadius: 0,
      overflow: "hidden",
      margin: 0,
      [theme.breakpoints.up("sm")]: {
        margin: 0,
      },
    }),
    root: ({ theme }) => ({
      "& .MuiBackdrop-root": {
        background: theme.palette.custom.backdrop,
      },
    }),
  },
};
